<template>
  <div>
    <AboutUs1 />
    <AboutUs2 />
  </div>
</template>

<script>
import AboutUs1 from "@/components/AboutUs/AboutUs1.vue";
import AboutUs2 from "@/components/AboutUs/AboutUs2.vue";

export default {
  name: "aboutUs", //igual ao path
  components: {
    AboutUs1,
    AboutUs2
  }
};
</script>

<style scoped></style>
